import { useQueryClient } from '@tanstack/react-query';

import { BulkSubscriptionEligibiltyParams, BulkSubscriptionEligibiltyResult } from '@app/domain-bundle-interfaces';
import { Axios } from '@app/web-components';

const BASE_URL = '/subscriptions';

export const UPLOAD_FILE_ALL_QUERY_KEY = 'UPLOAD_FILE_ALL_QUERY_KEY';

export const uploadFileKeys = {
  all: [UPLOAD_FILE_ALL_QUERY_KEY] as const,
  lists: () => [...uploadFileKeys.all, 'list'] as const,
  list: (filters: object) => [...uploadFileKeys.lists(), filters] as const,
  details: () => [...uploadFileKeys.all, 'detail'] as const,
  detail: (id: number) => [...uploadFileKeys.details(), id] as const,
};

export const useUploadFile = () => {
  const axios = Axios.useAxiosApi();
  const queryClient = useQueryClient();

  const uploadFile = (params: BulkSubscriptionEligibiltyParams) => {
    return queryClient.fetchQuery<BulkSubscriptionEligibiltyResult[]>({
      queryKey: uploadFileKeys.list(params),
      queryFn: async () => {
        const { data } = await axios.post(`${BASE_URL}/bulk-eligibility`, params);
        return data;
      },
    });
  };

  return uploadFile;
};
